// Format date for display
export const formatDate = (dateString) => {
  if (!dateString) return '—'
  try {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  } catch (e) {
    return dateString
  }
}

// Format date and time
export const formatDateTime = (dateString) => {
  if (!dateString) return '—'
  try {
    const date = new Date(dateString)
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  } catch (e) {
    return dateString
  }
}

// Get image URL — returns a fully-qualified URL so admin previews work
// across origins. Reads backend base from env.
export const getImageUrl = (imagePath) => {
  if (!imagePath) return ''
  if (/^https?:\/\//.test(imagePath)) return imagePath
  if (/^data:/.test(imagePath)) return imagePath
  const base = import.meta.env.VITE_API_BASE_URL || 'https://api.heet7studio.com'
  const clean = imagePath.replace(/^\/?(uploads\/)?/, '')
  if (!clean) return ''
  return `${base}/uploads/${clean}`
}

// Confirm dialog helper
export const confirmAction = (message) => {
  return window.confirm(message)
}

// Handle API errors
export const getErrorMessage = (error) => {
  if (error.response?.data?.msg) {
    return error.response.data.msg
  }
  if (error.message) {
    return error.message
  }
  return 'An error occurred. Please try again.'
}

// Truncate text
export const truncate = (text, length = 100) => {
  if (!text) return ''
  if (text.length <= length) return text
  return text.substring(0, length) + '...'
}

// Validate Instagram URL
export const isValidInstagramUrl = (url) => {
  if (!url) return true // Empty is valid (optional field)
  const regex = /^https?:\/\/(www\.)?(instagram\.com|instagr\.am)\/(reel|reels|p|tv)\/[A-Za-z0-9_-]+/i
  return regex.test(url)
}

// Validate email
export const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regex.test(email)
}

// Get file extension
export const getFileExtension = (filename) => {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)
}

// Format file size
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
}

export default {
  formatDate,
  formatDateTime,
  getImageUrl,
  confirmAction,
  getErrorMessage,
  truncate,
  isValidInstagramUrl,
  isValidEmail,
  getFileExtension,
  formatFileSize,
}
